@if (stateTaxesForm) {
  <form [formGroup]="stateTaxesForm" autocomplete="off">
    <div class=" content-container form-comp mb-3">
      <div class="title">
        <mwp-text-translate text="{{title}}" jsonKey="stateTaxW4" />
      </div>
      <div class="row content">
        <div class=" col-4">
          <mwp-datepicker [form]="stateTaxesForm" [minDate]="effectiveMinDate" labelName="Effective On" nameForControl="effectiveDate"/>
        </div>
        @if (stateTaxesForm) {
          <div class="col-4">
            <mwp-dropdown [form]="stateTaxesForm" labelName="State" nameForControl="state" (emitSelected)="stateUpdate($event)" [isListItemArray]="true" [data]="withholdingStates"/>
          </div>
        }
      </div>
      @if (isEditing) {
        <div class="d-flex my-2 justify-content-center">
          {{stateSelected}} - <mwp-text-translate text="State Tax" jsonKey="stateTax" class="ms-1" />
        </div>
      }
      @if (stateTaxDetail.exemptVisible) {
        <div class="row content">
          <div class="col-8 d-inline-flex">
            <mat-checkbox formControlName="isExempt" (change)="checkIsExempt($event)">
              <mwp-text-translate text="Is Exempt" jsonKey="isExempt" />
            </mat-checkbox>
            <mwp-radio-button [form]="stateTaxesForm" nameForControl="exemptStateTaxExemptFieldValue" [data]="stateTaxDetail.exemptTypes" keyText="text" keyValue="value" [autoTranslate]="false"/>
          </div>
          @if (stateTaxDetail.exemptYearEffectiveEnabled) {
            <div class="col-2">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.exemptYearEffectiveLabel}} nameForControl="exemptionYearEffective" [maskType]="maskType.numericValues"  [autoTranslate]="false"/>
            </div>
          }
          @if (stateTaxDetail.exemptFullTimeStudentEnabled) {
            <div class="col-3">
              <mat-checkbox formControlName="fullTimeStudent">
                <mwp-text-translate text="Is Full Time Student?" jsonKey="isFullTimeStudent" />
              </mat-checkbox>
            </div>
          }
        </div>
      }
      @if (isUniversalControl) {
        <div class="row content">
          @if (stateTaxDetail.legalResidenceVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.legalResidenceLabel}} nameForControl="legalResidence" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.legalResidenceSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.spouseLegalResidenceVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.spouseLegalResidenceLabel}} nameForControl="spouseLegalResidence" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.spouseLegalResidenceSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.filingStatusVisible) {
            <div class="col-4 my-3">
              <mwp-dropdown [form]="stateTaxesForm" labelName={{stateTaxDetail.filingStatusLabel}} nameForControl="filingStatusID" [isListItemArray]="true" [data]="stateTaxDetail.filingStatuses" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.filingStatusSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.alternativeCalcVisible) {
            <div class="col-4 my-3">
              <mwp-dropdown [form]="stateTaxesForm" labelName={{stateTaxDetail.alternativeCalcLabel}} nameForControl="alternativeCalcID" [isListItemArray]="true" [data]="stateTaxDetail.alternativeCalcs" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.alternativeCalcSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.dependentsVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.dependentsLabel}} nameForControl="numberOfDependents" [maskType]="maskType.numericValues" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.dependentsSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.gaAdjustmentsAllowanceVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.gaAdjustmentsAllowanceLabel}} nameForControl="georgiaAdjustmentsAllowance" [maskType]="maskType.numericValues" [maskType]="maskType.currency" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.gaAdjustmentsAllowanceSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.totalExemptionsVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.totalExemptionsLabel}} nameForControl="totalExemptions" [maskType]="maskType.numericValues" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.totalExemptionsSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.additionalAllowanceVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.additionalAllowanceLabel}} nameForControl="additionalAllowance" [maskType]="maskType.numericValues" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.additionalAllowanceSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.totalAllowancesVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.totalAllowancesLabel}} nameForControl="totalAllowances" [maskType]="maskType.numericValues" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.totalAllowancesSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.additionalAllowanceVisible2) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.additionalAllowanceLabel2}} nameForControl="additionalAllowance" [maskType]="maskType.numericValues" [autoTranslate]="false" />
              <mat-hint>{{stateTaxDetail.additionalAllowanceSubLabel2}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.lowIncomeVisible) {
            <div class="col-4 my-3">
              <mwp-button-toggle [form]="stateTaxesForm" nameForControl="lowIncome" [dataEnum]="booleanEnum" [label]="stateTaxDetail.lowIncomeLabel"  [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.lowIncomeSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.additionalWithholdingVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.additionalWithholdingLabel}} nameForControl="additionalWithholding" [maskType]="maskType.currency" [autoTranslate]="false" />
              <mat-hint>{{stateTaxDetail.additionalWithholdingSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.countyAdditionalWithholdingVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.countyAdditionalWithholdingLabel}} nameForControl="countyAdditionalWithholding" [maskType]="maskType.currency" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.countyAdditionalWithholdingSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.totalExemptionsVisible2) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.totalExemptionsLabel2}} nameForControl="totalExemptions" [maskType]="maskType.numericValues" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.totalExemptionsSubLabel2}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.reducedWithholdingVisible) {
            <div class="col-4 my-3">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.reducedWithholdingLabel}} nameForControl="reducedWithholding" [maskType]="maskType.numericValues" [autoTranslate]="false"/>
              <mat-hint>{{stateTaxDetail.reducedWithholdingSubLabel}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.county1Visible) {
            <div class="col-4 my-3">
              <mwp-dropdown [form]="stateTaxesForm" labelName={{stateTaxDetail.county1Label}} nameForControl="countyOfResidence" [isListItemArray]="true" [data]="stateTaxDetail.counties" [autoTranslate]="false"/>
            </div>
          }
          @if (stateTaxDetail.county2Visible) {
            <div class="col-4 my-3">
              <mwp-dropdown [form]="stateTaxesForm" labelName={{stateTaxDetail.county2Label}} nameForControl="countyOfEmployment" [isListItemArray]="true" [data]="stateTaxDetail.counties" [autoTranslate]="false"/>
            </div>
          }
          @if (stateTaxDetail.lowIncomeVisible2) {
            <div class="col-4 my-3">
              <mwp-button-toggle [form]="stateTaxesForm" nameForControl="lowIncome" [dataEnum]="booleanEnum" [label]="stateTaxDetail.lowIncomeLabel2" />
              <mat-hint>{{stateTaxDetail.lowIncomeSubLabel2}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.nonResidentVisible) {
            <div class="col-4 my-3">
              <mat-checkbox formControlName="nonResident">{{stateTaxDetail.nonResidentText}}</mat-checkbox>
            </div>
          }
          @if (stateTaxDetail.filingStatusVisible2) {
            <div class="col-4 my-3">
              <mwp-dropdown [form]="stateTaxesForm" labelName={{stateTaxDetail.filingStatusLabel2}} nameForControl="filingStatusID" [isListItemArray]="true" [data]="stateTaxDetail.filingStatuses" [autoTranslate]="false" />
              <mat-hint>{{stateTaxDetail.filingStatusSubLabel2}}</mat-hint>
            </div>
          }
          @if (stateTaxDetail.nonResidentVisible) {
            <div class="col-4 my-3">
              <mat-checkbox formControlName="nonResident">{{stateTaxDetail.nonResidentText}}</mat-checkbox>
            </div>
          }
          @if (stateTaxDetail.isBlindVisible) {
            <div class="col-4 my-3">
              <div>
                <mat-checkbox formControlName="isBlind">{{stateTaxDetail.isBlindLabel}}</mat-checkbox>
              </div>
              <div>
                <mat-hint>{{stateTaxDetail.isBlindSubLabel}}</mat-hint>
              </div>
            </div>
          }
          @if (stateTaxDetail.isSpouseBlindVisible) {
            <div class="col-4 my-3">
              <div>
                <mat-checkbox formControlName="isSpouseBlind">{{stateTaxDetail.isSpouseBlindLabel}}</mat-checkbox>
              </div>
              <div>
                <mat-hint>{{stateTaxDetail.isSpouseBlindSubLabel}}</mat-hint>
              </div>
            </div>
          }
          @if (stateTaxDetail.isStudentVisible) {
            <div class="col-3">
              <div>
                <mat-checkbox formControlName="fullTimeStudent">{{stateTaxDetail.isStudentLabel}}</mat-checkbox>
              </div>
              <div>
                <mat-hint>{{stateTaxDetail.isStudentSubLabel}}</mat-hint>
              </div>
            </div>
          }
        </div>
      }
      @if (isArizonaControl) {
        <div class="row content">
          <div class="col-12 fw-bold">
            {{stateTaxDetail.azCheckboxesLabel}}
          </div>
          <div class="col-12 mb-2">
            <div>
              <mat-checkbox formControlName="azCheckbox1" (change)="checkAZBox1($event)">
                <mwp-text-translate text="Box 1" jsonKey="box1" />
              </mat-checkbox>
            </div>
            <div class="content-container p-3">
              <div>
                {{stateTaxDetail.azAlternativeCalcLabel}}
              </div>
              <div>
                <mwp-radio-button [form]="stateTaxesForm" nameForControl="alternativeCalcID" [data]="stateTaxDetail.alternativeCalcs" keyText="text" keyValue="value" [autoTranslate]="false"/>
              </div>
              <div class="d-inline-flex">
                <div>
                  <mat-checkbox formControlName="azCheckboxExtraWithholding" (change)="checkAZBox1AdditonalWitholding($event)">{{stateTaxDetail.azCheckboxExtraWithholdingText}}</mat-checkbox>
                </div>
                <div class="ms-2">
                  <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.exemptYearEffectiveLabel}} nameForControl="additionalWithholding" [maskType]="maskType.currency" [autoTranslate]="false" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mb-2">
            <div>
              <mat-checkbox formControlName="azCheckbox2" (change)="checkAZBox2($event)">
                <mwp-text-translate text="Box 2" jsonKey="box2" />
              </mat-checkbox>
            </div>
            <div class="content-container p-3">
              {{stateTaxDetail.azCheckbox2Text}}
            </div>
          </div>
        </div>
      }
      @if (isNewYorkControl) {
        <div class="row content">
          <div class="col-4 my-3">
            <mwp-dropdown [form]="stateTaxesForm" labelName={{stateTaxDetail.filingStatusLabel}} nameForControl="filingStatusID" [isListItemArray]="true" [data]="stateTaxDetail.filingStatuses" [autoTranslate]="false" [autoTranslate]="false"/>
            <mat-hint>{{stateTaxDetail.filingStatusSubLabel}}</mat-hint>
          </div>
          <div class="col-4 my-3">
            <mwp-button-toggle [form]="stateTaxesForm" nameForControl="isNYNewYorkCityResident" [dataEnum]="booleanEnum" [label]="stateTaxDetail.nyIsNewYorkCityText" [autoTranslate]="false"/>
          </div>
          <div class="col-4 my-3">
            <mwp-button-toggle [form]="stateTaxesForm" nameForControl="isNYYonkersResident" [dataEnum]="booleanEnum" [label]="stateTaxDetail.nyIsYonkerResidentText"[autoTranslate]="false" />
          </div>
          <div class="col-4 my-3">
            <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.totalAllowancesLabel}} nameForControl="nyTotalAllowances" [autoTranslate]="false" [maskType]="maskType.numericValues" [autoTranslate]="false"/>
            <mat-hint>{{stateTaxDetail.totalAllowancesSubLabel}}</mat-hint>
          </div>
          <div class="col-4 my-3">
            <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.nyNewYorkCityTotalAllowancesLabel}} nameForControl="nycAllowances" [autoTranslate]="false" [maskType]="maskType.numericValues" [autoTranslate]="false"/>
            <mat-hint>{{stateTaxDetail.nyNewYorkCityTotalAllowancesSubLabel}}</mat-hint>
          </div>
          <div class="col-4 my-3">
            <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.additionalWithholdingLabel}} nameForControl="additionalWithholding" [autoTranslate]="false" [maskType]="maskType.currency" [autoTranslate]="false"/>
            <mat-hint>{{stateTaxDetail.additionalWithholdingSubLabel}}</mat-hint>
          </div>
          <div class="col-4 my-3">
            <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.nyNewYorkCityAdditionalWithholdingLabel}} nameForControl="nycAdditionalWithholding" [autoTranslate]="false" [maskType]="maskType.currency" [autoTranslate]="false"/>
            <mat-hint>{{stateTaxDetail.nyNewYorkCityAdditionalWithholdingSubLabel}}</mat-hint>
          </div>
          <div class="col-4 my-3">
            <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.nyYonkerAdditionalWithholdingLabel}} nameForControl="nyYonkersAdditionalWithholding" [autoTranslate]="false" [maskType]="maskType.currency" [autoTranslate]="false"/>
            <mat-hint>{{stateTaxDetail.nyYonkerAdditionalWithholdingSubLabel}}</mat-hint>
          </div>
        </div>
      }
      @if (stateTaxDetail.exemptVisibleEnd) {
        <div class="row content mb-3">
          <div class="col-8 d-inline-flex">
            <mat-checkbox formControlName="isExempt" (change)="checkIsExempt($event)">
              <mwp-text-translate text="Is Exempt" jsonKey="isExempt" />
            </mat-checkbox>
            <mwp-radio-button [form]="stateTaxesForm" nameForControl="exemptStateTaxExemptFieldValue" [data]="stateTaxDetail.exemptTypes" keyText="text" keyValue="value" [autoTranslate]="false"/>
          </div>
          @if (stateTaxDetail.exemptYearEffectiveEnabledEnd) {
            <div class="col-2">
              <mwp-input [form]="stateTaxesForm" labelName={{stateTaxDetail.exemptYearEffectiveLabelEnd}} nameForControl="exemptionYearEffective" [maskType]="maskType.numericValues" [autoTranslate]="false"/>
            </div>
          }
          @if (stateTaxDetail.exemptFullTimeStudentEnabledEnd) {
            <div class="col-3">
              <mat-checkbox [formControlName]="'fullTimeStudent'">
                <mwp-text-translate text="Is Full Time Student?" jsonKey="isFullTimeStudent" />
              </mat-checkbox>
            </div>
          }
        </div>
      }
    </div>
  </form>
}
@if (isEditing) {
  <div class="d-flex justify-content-end">
    <button class="mwp-button-secondary" (click)="cancel()">
      <mwp-text-translate text="cancel" jsonKey="Cancel" />
    </button>
    <button class="mwp-button-save ms-3" [disabled]="!stateTaxesForm.valid" (click)="save()">
      <mwp-text-translate text="Submit Change Request" jsonKey="submitChangeRequest" />
    </button>
  </div>
}